import React from 'react';

export default function Footer() {
  return (
    <div
      className='footer'
      style={{
        width: '100%',
        backgroundColor: 'black',
        padding: '40px',
      }}
    >
      &copy;Language Learning Library 2021
      <div style={{ display: 'inline-block', float: 'right' }}>
        <a href='/disclosure' style={{ margin: 20, padding: 10 }}>
          Affiliate Disclosure
        </a>
        <br />
        {/* <a href='/privacy' style={{ margin: 20 }}>
          Privacy Policy
        </a> */}
      </div>
    </div>
  );
}
